import { lazy, Suspense } from 'react';
// auth
import { StandardPolicyGuard } from 'src/auth/guard';
// layouts
import AppLayout from 'src/layouts/app';
// components
import { LoadingScreen } from 'src/components/loading-screen';

const WarehousesPage = lazy(() => import('src/pages/warehouses/warehouses'));

export const warehousesRoutes = [
  {
    path: 'warehouses',
    element: (
      <StandardPolicyGuard
        fallback={
          <AppLayout>
            <LoadingScreen />
          </AppLayout>
        }
      >
        <AppLayout>
          <Suspense fallback={<LoadingScreen />}>
            <WarehousesPage />
          </Suspense>
        </AppLayout>
      </StandardPolicyGuard>
    ),
  },
];
